import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import { MODE, TimePeriod } from 'models/baselines';
import { DateTimeFormat } from 'config/const';
import { ArrowUpDown } from 'components/ArrowUpDown';
import { getCompanyNameFromId } from '../Baselines.helpers';
import { BaselineItemCompanyViewDetailsProps } from '../Baselines.types';
import { BaselineItemTotals } from '../BaselineItemTotals/BaselineItemTotals';
import styles from './BaselineItemDetailsView.module.scss';
// import { BaselineTimeline } from '../BaselineTimeline/BaselineTimeline';

export const BaselineItemDetailsView = ({
  approvedPeriods,
  onExpandRowHandler
}: BaselineItemCompanyViewDetailsProps) => {
  const companyDetails = (period: TimePeriod, periodIndex: number) => {
    const { from, to, baselines, isExpanded } = period;
    return (
      <div className={styles.baselineItemViewWrapper} key={from}>
        {isExpanded ? (
          <div
            data-testid="toCollapse"
            className={styles.itemCompanyLineExpanded}
            role="button"
            tabIndex={0}
            onClick={() => onExpandRowHandler(periodIndex, false, MODE.VIEW)}
            onKeyDown={() => onExpandRowHandler(periodIndex, false, MODE.VIEW)}
            aria-label="button"
          />
        ) : (
          <div
            data-testid="toExpand"
            className={styles.itemCompanyLineCollapsed}
            role="button"
            tabIndex={0}
            onClick={() => onExpandRowHandler(periodIndex, true, MODE.VIEW)}
            onKeyDown={() => onExpandRowHandler(periodIndex, true, MODE.VIEW)}
            aria-label="button"
          />
        )}
        <div>
          <span className={styles.date}>
            {moment(from).format(DateTimeFormat.DatePicker)}
          </span>
        </div>
        <div>
          <span className={styles.date}>
            {moment(to).format(DateTimeFormat.DatePicker)}
          </span>
        </div>
        {isExpanded ? (
          <div className={styles.baselineItemVertical}>
            <div>
              <BaselineItemTotals period={period} />
            </div>
            {baselines.map((baseline) => {
              const companyName = getCompanyNameFromId(baseline.companyId);
              return (
                <div key={uuidv4()}>
                  <div>
                    <h1 className={styles.number}>{baseline.day}</h1>
                  </div>
                  <div>
                    <h1 className={styles.number}>{baseline.night}</h1>
                  </div>
                  <div>
                    <div className={styles.baselineItemCompanies}>
                      <h1 className={styles.company}>{companyName}</h1>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div>
            <BaselineItemTotals period={period} />
          </div>
        )}
        <ArrowUpDown isExpanded={isExpanded} />
      </div>
    );
  };

  return (
    <div className={styles.baselineItemVertical}>
      {approvedPeriods &&
        approvedPeriods.map((period: TimePeriod, index: number) => {
          return companyDetails(period, index);
        })}
      {/* <BaselineTimeline data={approvedPeriods} /> */}
    </div>
  );
};
